module.exports = __webpack_public_path__ + "img/13.e202d2a0.png";